export const STEPS = {
  ASKING_FOR_CONFIRMATION: 0,
  LOADING: 1,
  SUCCESS: 2,
};
